import { render, staticRenderFns } from "./DxDetailTabsBatches.vue?vue&type=template&id=0176e1c4&scoped=true&"
import script from "./DxDetailTabsBatches.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabsBatches.vue?vue&type=script&lang=js&"
import style0 from "./DxDetailTabsBatches.vue?vue&type=style&index=0&id=0176e1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0176e1c4",
  null
  
)

export default component.exports